import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_reason_code_parent_entities_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { id?: number, parent?: string, fullTextSearch?: string, $top?: number, $skip?: number }): Promise<{ result?: { Id?: number, Name?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_reason_code_parent_entities_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { id?: number, parent?: string, fullTextSearch?: string, $keys: number[] }): Promise<{ result?: { Id?: number, Name?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_reason_code_parent_entities_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      id?: number, parent?: string, fullTextSearch?: string    }) {
      return false;
    }
}
